import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      style={{
        borderTop: '1px solid #222',
        padding: '1.5rem',
        marginTop: '2rem',
        background: '#0a0a0a'
      }}
      data-testid="app-footer"
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem'
        }}>
          {/* Brand */}
          <div>
            <p style={{ fontWeight: '700', fontSize: '0.95rem', marginBottom: '0.25rem', color: '#ddd' }}>
              Atlas.IA
            </p>
            <p style={{ color: '#999', fontSize: '0.75rem' }}>
              VLM Corp. - Consultoria Empresarial Inteligente
            </p>
          </div>

          {/* Links */}
          <nav style={{ display: 'flex', flexWrap: 'wrap', gap: '1.25rem', alignItems: 'center' }}>
            <Link to="/privacidade" style={{ color: '#aaa', fontSize: '0.8rem', textDecoration: 'none' }} data-testid="footer-privacy-link"
              onMouseEnter={(e) => e.target.style.color = '#00ffff'}
              onMouseLeave={(e) => e.target.style.color = '#aaa'}>
              Privacidade
            </Link>
            <Link to="/reembolso" style={{ color: '#aaa', fontSize: '0.8rem', textDecoration: 'none' }} data-testid="footer-refund-link"
              onMouseEnter={(e) => e.target.style.color = '#00ffff'}
              onMouseLeave={(e) => e.target.style.color = '#aaa'}>
              Reembolso
            </Link>
            <Link to="/termos" style={{ color: '#aaa', fontSize: '0.8rem', textDecoration: 'none' }} data-testid="footer-terms-link"
              onMouseEnter={(e) => e.target.style.color = '#00ffff'}
              onMouseLeave={(e) => e.target.style.color = '#aaa'}>
              Termos de Uso
            </Link>
            <Link to="/contato" style={{ color: '#aaa', fontSize: '0.8rem', textDecoration: 'none' }} data-testid="footer-contact-link"
              onMouseEnter={(e) => e.target.style.color = '#00ffff'}
              onMouseLeave={(e) => e.target.style.color = '#aaa'}>
              Contato
            </Link>
          </nav>

          {/* Email */}
          <div style={{ textAlign: 'right' }}>
            <a href="mailto:suporteatlasia@hotmail.com" style={{ color: '#00ffff', fontSize: '0.8rem', textDecoration: 'none' }} data-testid="footer-email-link">
              suporteatlasia@hotmail.com
            </a>
            <p style={{ color: '#777', fontSize: '0.7rem', marginTop: '0.25rem' }}>
              {new Date().getFullYear()} Atlas.IA - Todos os direitos reservados
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
